var React = require('react');

function Divider (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"6.026","height":"101.847","key":0}),React.createElement("rect",{"y":"227.431","width":"6.026","height":"80.659","key":1})]);
}

Divider.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"6.026px","height":"308.09px","viewBox":"0 0 6.026 308.09","enableBackground":"new 0 0 6.026 308.09","xmlSpace":"preserve"};

module.exports = Divider;

Divider.default = Divider;
